export class VarianceCalculator {
    constructor() {
        this.n = 0;
        this.mean = 0;
        this.m2 = 0;
    }
    add(val) {
        this.n++;
        const delta = val - this.mean;
        this.mean += delta / this.n;
        this.m2 += delta * (val - this.mean);
    }
    getVariance() {
        return this.n <= 1 ? 0 : this.m2 / (this.n - 1);
    }
    getMean() {
        return this.mean;
    }
    getCoefficientOfVariation() {
        const variance = this.getVariance();
        return variance === 0 ? 0 : Math.abs(variance / this.getMean());
    }
}
//# sourceMappingURL=blink-statistics-library.js.map